// Simple in-memory cache for TasksBank lookup lists (task types + subjects).
// Each getter memoizes its promise so concurrent callers share one request
// and the list is fetched only once per page load. Call clear() after a
// mutation that could change a list.
import TasksService from "@/services/TasksService";
import CoursesService from "@/services/CoursesService";

let taskTypesPromise = null;
let subjectsPromise = null;

const toOptions = (r) => r.data.map((i) => ({ Value: i.id, Text: i.name }));

// TaskTypes returns a two-level tree: 16 parents, each with a subTypes array
// (empty for the 11 that have none). Keep the nested sub-type options on each
// parent option so the dialog can fill its second dropdown without a second
// request. Server order is meaningful (SortOrder, then Id) — never re-sort.
const toTypeTree = (r) => r.data.map((i) => ({
  Value: i.id,
  Text: i.name,
  SubTypes: (i.subTypes || []).map((s) => ({ Value: s.id, Text: s.name })),
}));

// Full tree, including each parent's sub-types.
const getTaskTypeTree = () => {
  if (!taskTypesPromise) {
    taskTypesPromise = TasksService.getTaskTypes()
      .then(toTypeTree)
      .catch((e) => { taskTypesPromise = null; throw e; }); // don't cache failures
  }
  return taskTypesPromise;
};

// Parents only, as flat { Value, Text } — for filter dropdowns that query TaskTypeId.
const getTaskTypes = () => getTaskTypeTree()
  .then((types) => types.map(({ Value, Text }) => ({ Value, Text })));

const getSubjects = () => {
  if (!subjectsPromise) {
    subjectsPromise = CoursesService.getCategories()
      .then(toOptions)
      .catch((e) => { subjectsPromise = null; throw e; });
  }
  return subjectsPromise;
};

const clear = () => {
  taskTypesPromise = null;
  subjectsPromise = null;
};

export default { getTaskTypes, getTaskTypeTree, getSubjects, clear };
